import { useEffect, useState } from "react";
import axios from "axios";
import { getAuthHeader } from "../utils/authHeader";

// MB-1611: is the MLS (Trestle) feed usable right now? Polled while the Listings
// page is open so the banner appears within a minute of an outage and clears
// within a minute of recovery. `message` carries the admin's reason when the
// feed was forced offline, else the generic customer wording from the api.
export interface MlsFeedStatus {
    online: boolean;
    data: boolean;
    photos: boolean;
    mode: "auto" | "forcedOffline";
    message?: string;
}

const POLL_MS = 60_000;

export const fetchMlsFeedStatus = async (): Promise<MlsFeedStatus> => {
    const headers = await getAuthHeader();
    const response = await axios.get<MlsFeedStatus>(
        `${process.env.REACT_APP_BACKEND_URL}/listing/mls-feed-status`,
        { headers, withCredentials: true },
    );
    return response.data;
};

export const useMlsFeedStatus = (enabled = true): MlsFeedStatus | null => {
    const [status, setStatus] = useState<MlsFeedStatus | null>(null);

    useEffect(() => {
        if (!enabled) return undefined;
        let cancelled = false;
        const tick = async () => {
            try {
                const next = await fetchMlsFeedStatus();
                if (!cancelled) setStatus(next);
            } catch {
                // A failed status read says nothing about the feed; keep what we had.
            }
        };
        tick();
        const interval = setInterval(tick, POLL_MS);
        return () => {
            cancelled = true;
            clearInterval(interval);
        };
    }, [enabled]);

    return enabled ? status : null;
};
